import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  specialPageContainer: {},
  todaySpecial: {
    display: 'flex',
    flexDirection: 'column',
    padding: '3rem 7rem',
  },
  todaySpecialTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    '& > span': {
      fontFamily: theme.fontFamilyArchivo,
      fontSize: '1.15rem',
      fontWeight: 500,
    },
    '& > a': {
      color: theme.lightCoralColor,
      fontFamily: theme.fontFamilyQuestrial,
    },
  },
  todaySpecialBody: {
    display: 'grid',
    gridGap: '2rem',
    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
    justifyItems: 'center',
    overflowY: 'hidden',
    height: '26rem',
    width: 'max-content',
    maxWidth: '100%',
    minWidth: '100%',
    marginTop: '3rem',
  },
  specialShopContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '3rem',
    padding: '4rem 7rem',
    paddingBottom: '5rem',
    backgroundColor: theme.whiteSmokeColor,
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '2rem',
      padding: '2rem 3rem',
      borderRadius: '20px',
      backgroundColor: theme.whiteColor,
    },
  },
  specialShopContainerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > span': {
      fontFamily: theme.fontFamilyArchivo,
      fontSize: '1.15rem',
      fontWeight: 500,
      textTransform: 'uppercase',
    },
    '& > a': {
      color: theme.lightCoralColor,
      fontFamily: theme.fontFamilyQuestrial,
    },
  },
  specialShopContainerLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '1rem',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& > a': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: '1rem',
      textTransform: 'uppercase',
      fontFamily: theme.fontFamilyLexendDeca,
      color: theme.darkSlateGrayColor,
    },
    '& > a:hover': {
      color: theme.lightCoralColor,
    },
    '& > a div': {
      height: '15rem',
      width: '15rem',
      background:
        'url("https://i.picsum.photos/id/312/500/500.jpg?hmac=ys8eh5ivAo4J0awMCxsFTTLa_VbjlbMbNztZmKkc_eg") no-repeat center center',
      backgroundSize: 'cover',
    },
  },
}));

export default useStyles;
